import Popper from '@di-shared/features/common/Popper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';

function EngineOilAndFilterAdvancedTooltip() {
  const {t} = useInferableTranslation();

  return (
    <Popper
      placement="bottom"
      className="tooltip"
      marginLeft={1.5}
      tooltip={
        <div role="tooltip">
          <strong className="tooltip_title">{t('T30018')}</strong>
          <p className="tooltip_text">{t('T30019')}</p>
          <ul className="tooltip_list">
            <li className="tooltip_item">{t('T30020')}</li>
            <li className="tooltip_item">{t('T30021')}</li>
          </ul>
        </div>
      }
    >
      <div className="tooltip_area tooltip_area_single">
        <button
          type="button"
          className="btn_tooltip"
          aria-describedby="tooltipBox01"
          aria-controls="tooltipStatement01"
          aria-expanded="false"
        >
          <span
            className="ic ic_information_14px"
            aria-hidden="true"
          />
        </button>
      </div>
    </Popper>
  );
}

export default EngineOilAndFilterAdvancedTooltip;
